const PATH = {
  LOGIN: "/login",
  HOME: "/",
  SETTINGS: "/settings",
  CORE_AI: `${process.env.REACT_APP_FE_URL}/ai-core/`,
};

export default PATH;
